import {
  bookToTaxCodeTagCodeColumnDefinition,
  bookToTaxCodeDescriptionColumnDefinition,
  countryTaxTypeColumnDefinition,
} from '../columnDefinitions';

export default [
  bookToTaxCodeTagCodeColumnDefinition,
  {
    ...bookToTaxCodeDescriptionColumnDefinition,
    headerName: 'Tag Description',
  },
  countryTaxTypeColumnDefinition,
];

